import { cn } from "@/lib/utils"

import { getToneClasses, type SemanticTone } from "./tone-styles"

const toneMap: Record<InlineStatusTone, SemanticTone> = {
  success: "success",
  error: "danger",
  info: "muted",
}

type InlineStatusTone = "success" | "error" | "info"

export function InlineStatus({
  tone,
  children,
  className,
}: {
  tone: InlineStatusTone
  children: string
  className?: string
}) {
  return (
    <div
      className={cn(
        "rounded-2xl border px-3 py-2 text-sm",
        getToneClasses(toneMap[tone]),
        className,
      )}
      role={tone === "error" ? "alert" : "status"}
      aria-live={tone === "error" ? "assertive" : "polite"}
      aria-atomic="true"
    >
      {children}
    </div>
  )
}
